import { useMediaQuery } from 'usehooks-ts'

import { DESKTOP_BREAKPOINT_WIDTH } from './constants'

export function useDesktopBreakpoint(): boolean {
  return useMediaQuery(`(min-width: ${DESKTOP_BREAKPOINT_WIDTH}px)`)
}
